<template>
  <div id="preview" v-if="detail.file_preview">
    <embed :src="detail.file_preview" ref="preview"
           type="application/pdf">
  </div>
</template>

<script>
  import {mapState} from 'vuex'

  export default {
    name: "DocumentPreview",
    computed: {
      ...mapState('Docflow', ['detail'])
    }
  }
</script>

<style scoped>
  embed {
    margin-top: 10px;
    width: 100%;
    height: calc(100vh - 330px);
  }
</style>